const initialState = {
  project: null,
  plugins: [],
  assets: [],
  permissionFlags: [],
  showCreatePage: false,
  showEmailSetting: false,
  selectedSnippet: null,
  showSidebar: true,
  showBuilderCanvasLoader: true,
  pages: [],
  events: [],
  pageDetail: null,
  collections: [],
  snippets: [],
  pageSnapshots: [],
  snippetSnapshots: [],
  layouts: [],
  externalApis: [],

  showImageSearchUploadError: false,
  showImageUploadLoader: false,
  showPageSnapshotName: false,
  createPagePending: false,
  createPageError: null,
  loadPagesPending: false,
  loadPagesError: null,
  loadCollectionsPending: false,
  loadCollectionsError: null,
  selectedCollection: null,
  selectedPage: null,
  items: [],
  totalItemPages: null,
  togglePageModal: false,
  toggleAsset: false,
  toggleAssetSearch: false,
  loadProjectPending: false,
  loadProjectError: null,
  loadInstalledPluginsPending: false,
  loadInstalledPluginsError: null,
  updatePagePending: false,
  updatePageError: null,
  createSnippetTemplatePending: false,
  createSnippetTemplateError: null,
  loadSnippetsPending: false,
  loadSnippetsError: null,
  loadProjectAssetsPending: false,
  loadProjectAssetsError: null,
  loadDefaultPagePending: false,
  loadDefaultPageError: null,
  changeDefaultPagePending: false,
  changeDefaultPageError: null,
  defaultPage: null,
  deletePagePending: false,
  deletePageError: null,
  fetchPageDetailPending: false,
  fetchPageDetailError: null,
  createPageSnapshotPending: false,
  createPageSnapshotError: null,
  loadPageSnapshotsPending: false,
  loadPageSnapshotsError: null,
  deletePageSnapshotPending: false,
  deletePageSnapshotError: null,
  uplodSearchedImagePending: false,
  uplodSearchedImageError: null,
  deleteAssetPending: false,
  deleteAssetError: null,
  deleteSnippetPending: false,
  deleteSnippetError: null,
  uploadImageFromUrlPending: false,
  uploadImageFromUrlError: null,
  updateSnippetPending: false,
  updateSnippetError: null,
  createSnippetSnapshotPending: false,
  createSnippetSnapshotError: null,
  loadSnippetSnapshotsPending: false,
  loadSnippetSnapshotsError: null,
  deleteSnippetSnapshotPending: false,
  deleteSnippetSnapshotError: null,
  loadEventsPending: false,
  loadEventsError: null,
  loadLayoutsPending: false,
  loadLayoutsError: null,
  loadExternalApisPending: false,
  loadExternalApisError: null,
  updateLatestPublishVersionPending: false,
  updateLatestPublishVersionError: null,
  getPermissionFlagsPending: false,
  getPermissionFlagsError: null,
  toggleDebugModePending: false,
  toggleDebugModeError: null,
};

export default initialState;
